/* eslint-disable camelcase */
/* eslint-disable no-redeclare */
/* eslint-disable block-scoped-var */
/* eslint-disable vars-on-top */
/* eslint-disable strict */

'use strict';

/**
 * Skeleton loader removal on window load.
 */
window.addEventListener('load', () => {
  const gocertifyScript = window.gocertify || null;

  document.querySelectorAll('[data-skeleton-loader]').forEach((skeleton) => {
    skeleton.classList.remove('skeleton');
  });

  document.querySelectorAll('[data-show-on-load]').forEach((el) => {
    el.classList.remove('invisible');
  });

  if (gocertifyScript) {
    document.querySelectorAll('[data-gocertify-link]').forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();

        const key = el.dataset.gocertifyKey;
        const eventName = el.dataset.gocertifyEvent;
        gocertifyScript.popup(key);
        window.monetateQ.push(['trackEvent', eventName]);
        const eventData = window.Simba.gtmConstructEventData('virtualPageView', {
          virtualPageViewValue: 'gocertifyView'
        });
        Simba.gtmPushEvent(eventData);
        return false;
      });
    });
  }

  // Colour picker initialization
  if (window.Simba.ColourPicker) {
    const pickers = document.querySelectorAll('[data-component="colour-picker"]');
    pickers.forEach((picker) => {
      const name = picker.dataset.optionName;
      new window.Simba.ColourPicker(picker, { name });
    });
  }
});

/**
 * Skeleton loader removal on dynamic content load.
 */
const skeletonTargetNode = document.getElementById('ab-test-container') || document.body;
const skeletonObserverConfig = { childList: true, subtree: true };
function skeletonObserverCallback(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.dataset && node.dataset.skeletonLoader !== undefined) {
          node.classList.remove('skeleton');
        }
      });
    }
  }
}
const skeletonObserver = new MutationObserver(skeletonObserverCallback);
skeletonObserver.observe(skeletonTargetNode, skeletonObserverConfig);

/**
 * INP interaction handler for optimising performance.
 */
(function CWV() {
  Simba.CWV = {
    interactionResponse: interactionResponse
  };

  function interactionResponse() {
    return new Promise((resolve) => {
      setTimeout(resolve, 100); // Fallback for the case where the animation frame never fires.
      requestAnimationFrame(() => {
        setTimeout(resolve, 0);
      });
    });
  }
})();

/**
 * Liquid utils.
 */
(function Liquid() {
  Simba.Liquid = {
    string: string,
    boolean: boolean,
    number: number
  };

  /**
   * Liquid JSON String To String
   * @param {String} input Liquid input.
   * @return {String}
   */
  function string(input) {
    if (typeof input === 'undefined') return '';
    // eslint-disable-next-line vars-on-top
    var output = input.replace(/(^")|("$)/g, '');
    return String(output);
  }

  /**
   * Liquid JSON String To Boolean
   * @param {String} input Liquid input.
   * @return {Boolean}
   */
  function boolean(input) {
    return input.replace(/(^")|("$)/g, '') === 'true' ? Boolean(true) : Boolean(false);
  }

  /**
   * Check If Comma Separator
   * @param {String} input
   * @return {Boolean}
   */
  function hasCommaSeparator(input) {
    return input.charAt(input.length - 3) === ',';
  }

  /**
   * Check If Decimal In Incorrect Place
   * @param {String} input
   * @return {Boolean}
   */
  function hasIncorrectDecimal(input) {
    return input.split('.').length - 1 > 1 || (input.indexOf('.') > -1 && input.charAt(input.length - 3) !== '.');
  }

  /**
   * Liquid JSON String To Number
   * @param {String} input Liquid input.
   * @return {Number}
   */
  function number(input) {
    var output = input.replace(/(^")|("$)/g, '').trim();
    if (hasCommaSeparator(output) || hasIncorrectDecimal(output)) {
      if (output.substr(output.length - 3).charAt(0) === ',') {
        // Replace All Separators & Add Decimal
        output = output.replace(/[^0-9]/g, '');
        output = output.substring(0, output.length - 2) + '.' + output.substring(output.length - 2);
      }
    }
    // Strip Any Commas
    output = output.replace(/,/g, '');
    return Number(output);
  }
})();

/**
 * Functional Methods
 */
(function Functional() {
  Simba.Functional = {
    compose: compose,
    partial: partial,
    nodeList: nodeList,
    head: head,
    debounce: debounce
  };

  /**
   * Returns the first element of the given list or string.
   * @param {Array} arr List
   * @example
   *   head(['fi', 'fo', 'fum']); //=> 'fi'
   * @return {*}
   */
  function head(arr) {
    return arr[0];
  }

  /**
   * Gets all nodes with a given selector.
   * @param {String} str CSS selector string.
   * @param {HTMLElement|optional} root Optional root node.
   * @example
   *   nodeList('div') => [div,div,div]
   * @return {Array} Matched elements
   */
  function nodeList(str, root) {
    var list;
    if (!root) root = document;
    list = root.querySelectorAll(str);
    return Array.prototype.slice.call(list);
  }

  /**
   * Partial Application
   * Takes a function `f` and a list of arguments, and returns a function `g`.
   * When applied, `g` returns the result of applying `f` to the arguments
   * When applied, `g` returns the result of applying `f` to the arguments
   * provided initially followed by the arguments provided to `g`.
   * @param {Function} fn
   * @return {Function} fn
   */
  function partial(fn /* , args... */) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 1);
    return function () {
      return fn.apply(this, args.concat(slice.call(arguments, 0)));
    };
  }

  /**
   * Performs right-to-left function composition.
   * The rightmost function may have any arity, the remaining functions must be unary.
   * @example
   *   function plus1(n) {return n + 1};
   *   function plus2(n) {return n + 2};
   *   compose(plus2,plus1)(1) => 4
   * @return {Function} Composed function
   */
  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();
    return function () {
      return funcs.slice(1).reduce(function (res, fn) {
        return fn(res);
      }, funcs[0].apply(undefined, arguments));
    };
  }

  /**
   * Creates a debounced function that delays invoking the provided function
   * until after the specified wait time has elapsed since the last call.
   * Optionally, it can execute immediately on the leading edge.
   *
   * @param {Function} func - The function to debounce.
   * @param {number} wait - The delay in milliseconds.
   * @param {boolean} [immediate=false] - If true, trigger the function on the leading edge.
   *
   * @returns {Function} - A debounced function.
   */
  function debounce(func, wait, immediate = false) {
    let timeout;

    return function (...args) {
      const context = this;
      const callNow = immediate && !timeout;

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);

      if (callNow) func.apply(context, args);
    };
  }
})();

/**
 * Collapsible.
 * @return {Array} public API.
 */
(function Collapsible() {
  var triggers = Simba.Functional.nodeList('[data-js-collapsible]');
  var init = Simba.Functional.compose(exposeAPI, setEvents, collateData);

  var publicAPI = triggers.map(init);
  Simba.Collapsible = publicAPI;
  return publicAPI;

  // **************************

  /**
   * Get elements.
   * @param {HTMLElement} trigger Button with data-js-collapsible attribute.
   * @return {Object} Object with instance data.
   */
  function collateData(trigger) {
    var instanceName = trigger.getAttribute('data-js-collapsible');
    return {
      trigger: trigger,
      triggerText: $.makeArray(trigger.querySelectorAll('[data-collapsible-detail]')),
      closeTrigger: document.querySelector('[data-js-close-collapsible="' + instanceName + '"]'),
      panel: trigger.nextElementSibling,
      instanceName: trigger.getAttribute('data-js-collapsible'),
      isGroup: trigger.hasAttribute('data-js-collapsible-group'),
      isPushable: trigger.hasAttribute('data-js-pushable')
    };
  }

  /**
   * Add 'click' events.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function setEvents(obj) {
    obj.trigger.addEventListener('click', Simba.Functional.partial(toggle, obj));
    if (obj.closeTrigger) {
      obj.closeTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        collapse(obj);
      });
    }
    return obj;
  }

  /**
   * Add 'collapse' and 'expand' methods to instance data.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function exposeAPI(obj) {
    return {
      collapse: Simba.Functional.partial(collapse, obj),
      expand: Simba.Functional.partial(expand, obj),
      isExpanded: Simba.Functional.partial(isExpanded, obj),
      instanceName: obj.instanceName,
      isGroup: obj.isGroup
    };
  }

  /**
   * Toggle panel based on 'aria-expanded' attribute.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function toggle(obj) {
    isExpanded(obj) ? collapse(obj) : expand(obj);
    return obj;
  }

  /**
   * Expand panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function expand(obj) {
    obj.triggerText.forEach(function (element) {
      element.toggleAttribute('hidden');
    });
    if (obj.isGroup) collapseGroup(obj);
    if (!obj.panel) return obj;
    obj.trigger.setAttribute('aria-expanded', true);
    obj.panel.removeAttribute('hidden');
    if (obj.panel.getAttribute('data-js-collapsible-no-animate')) {
      animate(obj.panel, 'normal', obj.isGroup, obj.instanceName);
    } else {
      emitEvent('normal', obj.instanceName);
    }
    return obj;
  }

  /**
   * Collapse panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function collapse(obj) {
    obj.triggerText.forEach(function (element) {
      element.toggleAttribute('hidden');
    });
    obj.trigger.setAttribute('aria-expanded', false);
    if (!obj.isPushable) {
      if (!obj.panel) return obj;
      obj.panel.setAttribute('hidden', true);
      if (obj.panel.getAttribute('data-js-collapsible-no-animate')) {
        animate(obj.panel, 'reverse', obj.isGroup, obj.instanceName);
      }
    }
    return obj;
  }

  /**
   * Collapse all expanded instances of the same group.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function collapseGroup(obj) {
    var groupInstances = Simba.Collapsible.filter(function filterByName(instance) {
      return instance.instanceName === obj.instanceName && obj.trigger !== instance.trigger && instance.isExpanded();
    });

    groupInstances.forEach(function collapseInstance(instance) {
      instance.collapse();
    });

    return obj;
  }

  /**
   * Instance expanded state.
   * @param {Object} obj Instance data.
   * @return {Boolean} Instance state.
   */
  function isExpanded(obj) {
    return obj.trigger.getAttribute('aria-expanded') === 'true' ? Boolean(true) : Boolean(false);
  }

  /**
   * Panel animation.
   * @param {HTMLElement} element Panel element to animate.
   * @param {String} direction Animation direction, normal or reverse.
   * @param {Boolean} isGroup Animated panel is part of a radio group.
   * @param {String} instanceName Collapsible instance name.
   * @return {undefined} Nothing to return.
   */
  function animate(element, direction, isGroup, instanceName) {
    element.setAttribute('data-is-animating', true);

    element.animate([{ height: 0 }, { height: element.offsetHeight + 'px' }], {
      duration: 180,
      fill: 'both',
      easing: isGroup ? 'ease-in-out' : 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      direction: direction
    }).onfinish = function () {
      element.removeAttribute('data-is-animating');
      emitEvent(direction, instanceName);
      this.cancel();
    };
  }

  /**
   * Emit collapse/expand events.
   * @example:
   *    'collapsible:collapse:promobar' => event triggered on promobar close
   *    'collapsible:expand:promobar' => event triggered on promobar open
   * @param {String} direction Animation direction, normal or reverse.
   * @param {String} instanceName Collapsible instance name.
   */
  function emitEvent(direction, instanceName) {
    var eventName = direction === 'reverse' ? ':collapse:' : ':expand:';
    Simba.Event.emit('collapsible' + eventName + instanceName);
  }
})();

/**
 * Video Modal.
 * @return {Array} public API.
 */
(function VideoModal() {
  var triggers = Simba.Functional.nodeList('[data-js-video-modal]');
  var init = Simba.Functional.compose(exposeAPI, setEvents, collateData);

  var publicAPI = triggers.map(init);
  Simba.VideoModal = publicAPI;
  return publicAPI;

  //* *************************

  /**
   * Get elements.
   * @param {HTMLElement} trigger Button with data-js-video-modal attribute.
   * @return {Object} Object with instance data.
   */
  function collateData(trigger) {
    return {
      trigger: trigger,
      src: trigger.getAttribute('data-js-video-modal')
    };
  }

  /**
   * Add 'click' events.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function setEvents(obj) {
    obj.trigger.addEventListener('click', Simba.Functional.partial(toggle, obj));
    return obj;
  }

  /**
   * Add 'collapse' and 'expand' methods to instance data.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function exposeAPI(obj) {
    return {
      trigger: obj.trigger,
      close: Simba.Functional.partial(close, obj),
      open: Simba.Functional.partial(open, obj)
    };
  }

  /**
   * Toggle panel based on 'aria-expanded' attribute.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function toggle(obj, evt) {
    evt.preventDefault();

    obj.trigger.getAttribute('aria-expanded') === 'true' ? close(obj) : open(obj);
    return obj;
  }

  function createMarkup(obj) {
    obj.container = document.createElement('div');
    obj.container.className = 'fixed top-0 left-0 w-full h-full z-modal bg-scrim';
    obj.container.innerHTML =
      '<div class="ratio-16x9 w-full max-w-900 abs-center">' +
      '<iframe class="w-full max-w-900" src="' +
      obj.src +
      '" frameborder="0" allowfullscreen=""></iframe>' +
      '<button type="button" class="absolute right-0" style="top: -40px; padding: 8px;" aria-label="close modal">' +
      '<img class="block" src="https://cdn.shopify.com/s/files/1/1059/4836/files/icon-close.svg?654894" alt="Close">' +
      '</button>' +
      '</div>';
    obj.closeTrigger = obj.container.querySelector('button');
    return obj;
  }

  function appendMarkup(obj) {
    insertAfter(obj.container, obj.trigger);
    return obj;
  }

  function removeMarkup(obj) {
    obj.trigger.parentElement.removeChild(obj.container);
    return obj;
  }

  /**
   * Expand panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function open(obj) {
    Simba.Functional.compose(setCloseEvents, appendMarkup, createMarkup)(obj);
    obj.trigger.setAttribute('aria-expanded', true);
    return obj;
  }

  /**
   * Collapse panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function close(obj) {
    Simba.Functional.compose(removeMarkup, removeCloseEvents)(obj);
    obj.trigger.setAttribute('aria-expanded', false);
    return obj;
  }

  function setCloseEvents(obj) {
    obj.closeFn = Simba.Functional.partial(close, obj);
    obj.closeTrigger.addEventListener('click', obj.closeFn, true);
    window.addEventListener('keyup', obj.closeFn, true);
    return obj;
  }

  function removeCloseEvents(obj) {
    obj.closeTrigger.removeEventListener('click', obj.closeFn, true);
    window.removeEventListener('keyup', obj.closeFn, true);
    return obj;
  }

  /*
  function keyboardClose(obj, evt) {
    if (evt.key === 'Escape' || evt.key === 'Esc' || evt.keyCode === 27)
      obj.closeFn();
  }
  */

  /**
   * Insert node after node.
   * @param {HTMLElement} newNode Node to be appended
   * @param {HTMLElement} referenceNode Refference node
   * @return {HTMLElement} newNode
   */
  function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    return newNode;
  }
})();

(function SliderInit() {
  var instances = Simba.Functional.nodeList('[data-slick-init]');
  var init = Simba.Functional.compose(initLazyLoad, setEvents, initSlider, collateData, getConfig);

  var publicAPI = instances.map(init);
  Simba.Sliders = publicAPI;
  return publicAPI;

  //* *************************

  function getConfig(instance) {
    return JSON.parse(instance.innerHTML);
  }

  function collateData(config) {
    var disableAbove = 0;

    if (config.settings.appendDots) {
      config.settings.appendDots = $(config.settings.appendDots);
    }
    if (config.disableAbove) {
      if (parseInt(config.disableAbove, 10) > 0) {
        disableAbove = parseInt(config.disableAbove, 10);
      }
    }
    return {
      selector: config.selector,
      container: $(config.selector),
      settings: config.settings,
      disableAbove: disableAbove,
      $triggers: $($(config.selector).attr('data-slider-controls'))
    };
  }

  function initSlider(config) {
    var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if (config.disableAbove > 0) {
      if (vw > config.disableAbove) {
        // eslint-disable-next-line no-console
        // console.debug('Slick disabled above: ' + config.disableAbove);
        return config;
      }
    }
    if (config.container.hasClass('slick-initialized')) {
      // eslint-disable-next-line no-console
      // console.debug('Slick already init for: ' + config.selector);
    } else {
      config.slider = config.container.slick(config.settings);
    }
    return config;
  }

  function setEvents(config) {
    var index;

    if (config.$triggers.length) {
      config.$triggers.on('click', function setSlide() {
        index = this.getAttribute('data-index');
        config.container.slick('slickGoTo', index);
        setTriggerState(config, index);
      });

      config.container.on('afterChange', function (event, slick, currentSlide) {
        setTriggerState(config, currentSlide);
      });
    }

    if (config.disableAbove > 0) {
      window.addEventListener('resize', function () {
        var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (vw > config.disableAbove) {
          if (config.container.hasClass('slick-initialized')) {
            config.container.slick('unslick');
          }
        } else {
          initSlider(config);
        }
      });
    }

    return config;
  }

  function initLazyLoad(config) {
    var isLazy = Boolean(config.container.find('[data-lazy-slider]').length);
    var lazyList1;
    var lazyList2;

    if (isLazy) {
      config.container.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        lazyList1 = $.makeArray(slick.$slides.eq(nextSlide).find('[data-lazy-slider]'));
        lazyList2 = $.makeArray(slick.$slides.eq(nextSlide + 1).find('[data-lazy-slider]'));

        lazyLoad(lazyList1);
        lazyLoad(lazyList2);
      });
    }

    return config;
  }

  function lazyLoad(lazyList) {
    lazyList.forEach(function (element) {
      var src = element.getAttribute('data-lazy-slider');
      element.src ? element.setAttribute('src', src) : element.setAttribute('srcset', src);
      element.removeAttribute('data-lazy-slider');
    });
  }

  function setTriggerState(config, index) {
    if (!config.$triggers.eq(index).attr('data-index')) {
      index++;
    }
    config.$triggers.removeAttr('data-slider-trigger-active');
    config.$triggers.eq(index).attr('data-slider-trigger-active', true);
  }
})();

/**
 * Model Driven View.
 * XXX Add documentation.
 */
(function ModelDrivenView() {
  Simba.ModelDrivenView = {
    init: MDV
  };

  /* eslint-disable vars-on-top, no-redeclare, block-scoped-var */
  function MDV($root) {
    // eslint-disable-next-line
    return new Proxy(
      {
        setOriginalPrice: null,
        setPrice: null,
        setProductTitle: null,
        setProductDescription: null,
        setHasFinance: null,
        setHasDiscount: null,
        setNotHasDiscount: null,
        setHasCompareAtPrice: null,
        setCompareAtPrice: null,
        setInstalmentPrice: null,
        setInstalmentMonths: null,
        setVariantTitle: null,
        setVariantSelect: null,
        setAtcVariantId: null,
        setAtcExternalURL: null,
        setEcoTax: null,
        disableAtcButton: null
      },
      {
        set: function (obj, prop, newVal) {
          var $view;
          var $priceElements;

          if (prop === 'setOriginalPrice') {
            $priceElements = $root.get(0).querySelectorAll('[data-mdv-original-price]');
            for (var i = 0; i < $priceElements.length; i++) {
              $priceElements[i].innerText = newVal;
            }
          }

          if (prop === 'setPrice') {
            $priceElements = document.querySelectorAll('[data-mdv-price]');
            for (var i = 0; i < $priceElements.length; i++) {
              $priceElements[i].innerText = newVal;
            }
          }

          if (prop === 'setHasFinance') {
            $view = $root.get(0).querySelectorAll('[data-mdv-has-finance]');

            if ($view !== null) {
              $view.forEach(function (view) {
                if (newVal === true) {
                  view.removeAttribute('hidden');
                } else {
                  view.setAttribute('hidden', true);
                }
              });
            }
          }

          if (prop === 'setHasDiscount') {
            $view = $root.get(0).querySelectorAll('[data-mdv-has-discount]');
            if ($view !== null) {
              $view.forEach(function (view) {
                if (newVal === true) {
                  view.removeAttribute('hidden');
                } else {
                  view.setAttribute('hidden', true);
                }
              });
            }
          }

          if (prop === 'setNotHasDiscount') {
            $view = $root.get(0).querySelectorAll('[data-mdv-not-has-discount]');
            if ($view !== null) {
              $view.forEach(function (view) {
                if (newVal === true) {
                  view.removeAttribute('hidden');
                } else {
                  view.setAttribute('hidden', true);
                }
              });
            }
          }

          if (prop === 'setDiscountPercent') {
            $view = $root.get(0).querySelectorAll('[data-mdv-discount-percent]');
            for (var i = 0; i < $view.length; i++) {
              $view[i].innerText = newVal;
            }
          }

          if (prop === 'setDiscountPercentBase') {
            $view = $root.get(0).querySelectorAll('[data-mdv-discount-percent-base]');
            for (var i = 0; i < $view.length; i++) {
              $view[i].innerText = newVal;
            }
          }

          if (prop === 'setSavingTotal') {
            $view = $root.get(0).querySelectorAll('[data-mdv-total-saving]');
            for (var i = 0; i < $view.length; i++) {
              $view[i].innerText = newVal;
            }
          }

          if (prop === 'setCompareAtSavingTotal') {
            $view = $root.get(0).querySelectorAll('[data-mdv-compare-at-saving]');
            for (var i = 0; i < $view.length; i++) {
              $view[i].innerText = newVal;
            }
          }

          if (prop === 'setHasCompareAtPrice') {
            $view = $root.get(0).querySelector('[data-mdv-has-compare-at-price]');
            if ($view !== null) {
              if (newVal === true) {
                $view.removeAttribute('hidden');
              } else {
                $view.setAttribute('hidden', true);
              }
            }
          }

          if (prop === 'setCompareAtPrice') {
            $view = $root.get(0).querySelectorAll('[data-mdv-compare-at-price]');
            for (var i = 0; i < $view.length; i++) {
              $view[i].innerText = newVal;
            }
          }

          if (prop === 'setInstalmentPrice') {
            $view = $root.get(0).querySelectorAll('[data-mdv-instalment-price]');
            if ($view !== null) {
              for (var i = 0; i < $view.length; i++) {
                $view[i].innerText = newVal;
              }
            }
          }

          if (prop === 'setOriginalInstalmentPrice') {
            $view = $root.get(0).querySelectorAll('[data-mdv-original-instalment-price]');
            if ($view !== null) {
              for (var i = 0; i < $view.length; i++) {
                $view[i].innerText = newVal;
              }
            }
          }

          if (prop === 'setInstalmentMonths') {
            $view = $root.get(0).querySelector('[data-mdv-instalment-months]');
            if ($view !== null) {
              $view.innerText = newVal;
            }
          }

          if (prop === 'setVariantTitle') {
            $view = $root.get(0).querySelector('[data-mdv-variant-title]');
            if ($view !== null) {
              $view.innerText = newVal;
            }
          }

          if (prop === 'setProductTitle') {
            $view = $root.get(0).querySelector('[data-mdv-product-title]');
            if ($view !== null) {
              $view.innerText = newVal;
            }
          }

          if (prop === 'setProductDescription') {
            $view = $root.get(0).querySelector('[data-mdv-product-description]');
            if ($view !== null) {
              $view.innerText = newVal;
            }
          }

          if (prop === 'setVariantSelect') {
            $view = $root.get(0).querySelector('[data-variant-select]');
            if ($view !== null) {
              $view.val = newVal;
            }
          }

          if (prop === 'setAtcVariantId') {
            $view = $root.get(0).querySelector('[data-mdv-atc]');
            if ($view !== null) {
              $view.setAttribute('data-mdv-atc', newVal);
            }
          }

          if (prop === 'setAtcExternalURL') {
            $view = $root.get(0).querySelector('[data-mdv-atc-external]');
            if ($view !== null) {
              $view.setAttribute('href', newVal);
            }
          }

          if (prop === 'setEcoTax') {
            $view = $root.get(0).querySelector('[data-mdv-ecotax]');
            if ($view !== null) {
              $view.innerText = newVal;
            }
          }

          if (prop === 'disableAtcButton') {
            $view = $root.get(0).querySelector('[data-mdv-atc]');
            if ($view !== null) {
              $view.setAttribute('disabled', true);
            }
          }

          if (prop === 'disableView') {
            if (newVal === true) {
              $root.setAttribute('data-mdv-disabled', true);
              $root.get(0).querySelector('[data-mdv-atc]').setAttribute('disabled', true);
            } else {
              $root.removeAttribute('data-mdv-disabled');
              $root.get(0).querySelector('[data-mdv-atc]').removeAttribute('disabled');
            }
          }

          // The default behavior to store the value
          obj[prop] = newVal;

          // Indicate success
          return true;
        }
      }
    );
  }

  /* eslint-enable vars-on-top, no-redeclare, block-scoped-var */
})();

(function Money() {
  Simba.Money = {
    format: formatMoney
  };

  /**
   * Shopify money format.
   * @param {Number} cents Ammout.
   * @param {String} format Format pattern.
   * @param {String} formated string
   */
  function formatMoney(format, cents) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var moneyFormat = Simba.Liquid.string('"£{{amount_no_decimals}}"');
    var thousandsSeparator = Simba.Liquid.string('","');
    var decimalSeparator = Simba.Liquid.string('"."');
    var zeroDecimal = decimalSeparator + '00';
    var formatString = format || moneyFormat;

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      var parts;
      var dollarsAmount;
      var centsAmount;
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, thousandsSeparator);
      decimal = defaultOption(decimal, decimalSeparator);

      if (isNaN(number) || number === null) return 0;

      number = (number / 100.0).toFixed(precision);
      parts = number.split('.');
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        // Return no decimals when we have a round price
        // E.g.: 84900 => 849
        // Preaserve actual value when the price contains a decimal
        // E.g.: 63675 => 636.75
        value = formatWithDelimiters(cents, 2).replace(zeroDecimal, '');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, decimalSeparator, thousandsSeparator);
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, decimalSeparator, thousandsSeparator);
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }
})();

/**/
(function Finance() {
  var instances = Simba.Functional.nodeList('[data-finance]');
  var init = Simba.Functional.compose(initEvents, collateData);

  var publicAPI = instances.map(init);
  Simba.Finance = publicAPI;
  return publicAPI;

  // **************************

  function collateData(element) {
    var $container = element;
    var isCartInstance = $container.getAttribute('data-finance') === 'cart';

    return {
      $container: $container,
      $price: $container.querySelector('[data-finance-price]'),
      $originalPrice: $container.querySelector('[data-finance-original-price]'),
      $instalmentPrice: $container.querySelector('[data-finance-instalment-price]'),
      $discountState: $container.querySelector('[data-has-discount]'),
      updateEvent: isCartInstance ? 'cart:change' : 'variant:change'
    };
  }

  function initEvents(instance) {
    document.addEventListener(instance.updateEvent, Simba.Functional.partial(update, instance), false);
    return instance;
  }

  function update(instance, evt) {
    var variantOrCart = evt.detail.cart || evt.detail.variant;
    var finance = variantOrCart.finance;

    instance.$container.setAttribute('data-has-finance', finance.hasFinance);
    instance.$discountState.setAttribute('data-has-discount', finance.hasDiscount);
    instance.$price.innerText = finance.priceFormatted;
    instance.$originalPrice.innerText = finance.originalPriceFormattedWithoutTrailingZeros;
    instance.$instalmentPrice.innerText = finance.lowestInstalmentPriceFormatted;
  }
})();

/**
 * Product and cart finance calculator.
 */
(function FinanceCalculator() {
  var instances = Simba.Functional.nodeList('[data-finance-calculator]');
  var init = Simba.Functional.compose(initEvents, collateData);

  var publicAPI = instances.map(init);
  Simba.FinanceCalculator = publicAPI;
  return publicAPI;

  // **************************

  /**
   * Get instance initial data.
   * @param {HTMLElement} element Element with data-finance-calculator attribute.
   * @return {Object} Object with instance data.
   */
  function collateData(element) {
    var $container = element;
    var isCartInstance = $container.getAttribute('data-finance-calculator') === 'cart';

    return {
      updateEvent: isCartInstance ? 'cart:change' : 'variant:change',
      handle: element.getAttribute('data-finance-calculator'),
      $container: $container,
      $financeContainer: document.querySelector('[data-mdv-has-finance]'),
      $priceTotal: $container.querySelectorAll('[data-finance-calculator-total]'),
      $priceInstalments: $container.querySelectorAll('[data-finance-calculator-instalment]'),
      $instalment12: $container.querySelector('[data-finance-instalment="12"]'),
      $instalment24: $container.querySelector('[data-finance-instalment="24"]'),
      $instalment36: $container.querySelector('[data-finance-instalment="36"]'),
      $instalment48: $container.querySelector('[data-finance-instalment="48"]'),
      financeThreshold: Simba.Liquid.number('"15000"'),
      financeThresholdMonths: Simba.Liquid.number('"12"'),
      instalment12Threshold: Simba.Liquid.number('"25000"'),
      instalment12ThresholdMonths: Simba.Liquid.number('"48"')
    };
  }

  /**
   * Set events based on calculator type.
   *   'variant:change' product variant change event
   *   'cart:change' cart change event
   * @param {Object} data Object with instance data.
   * @return {Object} Object with instance data.
   */
  function initEvents(instance) {
    document.addEventListener(instance.updateEvent, Simba.Functional.partial(update, instance), false);
    return instance;
  }

  function update(instance, evt) {
    var variantOrCart = evt.detail.cart || evt.detail.variant;
    if (!variantOrCart) return;

    instance.finance = variantOrCart.finance;
    Simba.Functional.compose(instalmentVisibility, updatePrice)(instance);
  }

  /**
   * Set calculator total price and instalments prices.
   * @param {Object} data Object with instance data.
   * @return {Object} Object with instance data.
   */
  function updatePrice(instance) {
    var container = instance.updateEvent === 'variant:change' ? '#pdp-alma' : '#cart-alma';
    if (undefined !== window.simbaalma && instance.finance.price > 0) {
      window.simbaalma.widgets.add(window.Alma.Widgets.PaymentPlans, {
        container: container,
        purchaseAmount: instance.finance.price,
        locale: 'fr',
        hideIfNotEligible: true,
        monochrome: false,
        plans: [
          {
            installmentsCount: 3,
            minAmount: 25000,
            maxAmount: 300000
          },
          {
            installmentsCount: 4,
            minAmount: 25000,
            maxAmount: 300000
          },
          {
            installmentsCount: 10,
            minAmount: 34900,
            maxAmount: 300000
          }
        ]
      });
    }

    instance.$priceTotal.forEach(function updateInstalmentTotalPrice(instalment) {
      instalment.innerText = instance.finance.priceFormatted;
    });
    instance.$priceInstalments.forEach(function updateInstalmentPrice(instalment, idx) {
      instalment.textContent = instance.finance.instalmentPriceFormatted[idx];
    });
    return instance;
  }

  /**
   * Toggle Finance Modal & 12 months instalment visibility.
   * @param {Object} data Object with instance data.
   * @return {Object} Object with instance data.
   */
  // eslint-disable-next-line consistent-return
  function instalmentVisibility(instance) {
    if (instance.$financeContainer && instance.updateEvent !== 'cart:change') {
      if (instance.finance.price < instance.financeThreshold) {
        instance.$financeContainer.classList.add('hidden');
      } else {
        instance.$financeContainer.classList.remove('hidden');
      }
    }
    if (instance.$instalment12) {
      if (instance.finance.price >= instance.financeThreshold) {
        instance.$instalment12.removeAttribute('hidden');
      } else {
        instance.$instalment12.setAttribute('hidden', true);
      }
    }
    if (instance.$instalment24) {
      if (instance.finance.price > instance.instalment12Threshold) {
        instance.$instalment24.removeAttribute('hidden');
      } else {
        instance.$instalment24.setAttribute('hidden', true);
      }
    }
    if (instance.$instalment36) {
      if (instance.finance.price > instance.instalment12Threshold) {
        instance.$instalment36.removeAttribute('hidden');
      } else {
        instance.$instalment36.setAttribute('hidden', true);
      }
    }
    if (instance.$instalment48) {
      if (instance.finance.price > instance.instalment12Threshold) {
        instance.$instalment48.removeAttribute('hidden');
      } else {
        instance.$instalment48.setAttribute('hidden', true);
      }
    }

    return instance;
  }
})();

(function V12Finance() {
  Simba.V12Finance = {
    calculateV12Values: calculateV12Values,
    getFinanceProducts: getFinanceProducts,
    generateDescription: generateDescription
  };

  let financeProducts = [];
  const financeProductsJsonElement = document.querySelector('[data-v12-finance-products]');
  if (financeProductsJsonElement) {
    financeProducts = JSON.parse(document.querySelector('[data-v12-finance-products]').innerHTML);
  }

  function getFinanceProducts() {
    return financeProducts;
  }

  function getFinanceProductByMonthsAndIsInterestBearing(months) {
    /* eslint-disable vars-on-top */
    for (var i = 0; i < financeProducts.length; i++) {
      if (financeProducts[i].months === months && financeProducts[i].apr > 0.0) {
        return financeProducts[i];
      }
    }
    return null;
  }

  /* eslint-disable vars-on-top */
  function calculateV12Values(price, months) {
    const financeProduct = getFinanceProductByMonthsAndIsInterestBearing(months);
    var apr = financeProduct ? financeProduct.apr : 0.0;
    var monthlyrate = financeProduct ? financeProduct.monthlyRate : 0.0;
    var calculatedApr;
    var balancePayable = 0;

    var cashPrice = parseFloat(price);

    var loanAmount = cashPrice;
    var initialPayments;
    var finalPayment;

    balancePayable = loanAmount;

    if (monthlyrate === 0) {
      initialPayments = Math.round((loanAmount / months) * 100) / 100;

      if (initialPayments * months < loanAmount) {
        initialPayments += 0.01;
      }

      finalPayment = loanAmount - initialPayments * (months - 1);

      calculatedApr = 0;
    } else {
      var theYield = Math.pow(apr / 100 + 1, 1.0 / 12);

      var pv = loanAmount;

      initialPayments = Math.ceil((0 - pv / ((Math.pow(theYield, 0 - months) - 1) / (theYield - 1))) * 100) / 100;

      finalPayment = initialPayments;

      balancePayable = initialPayments * months;

      calculatedApr = calculateApr(loanAmount, initialPayments, months);
    }

    var interest = balancePayable - loanAmount;

    var chargeForCredit = interest;

    var amountPayable = balancePayable;

    var annualRate = ((interest / loanAmount) * 100) / (months / 12);

    var financeCalculation = {
      initialPayments: initialPayments.toFixed(2),
      finalPayment: finalPayment.toFixed(2),
      balancePayable: balancePayable.toFixed(2),
      interest: interest.toFixed(2),
      chargeForCredit: chargeForCredit.toFixed(2),
      amountPayable: amountPayable.toFixed(2),
      cashPrice: cashPrice.toFixed(2),
      loanAmount: loanAmount.toFixed(2),
      months: months,
      apr: calculatedApr.toFixed(2),
      annualRate: annualRate.toFixed(2)
    };

    return financeCalculation;
  }

  function calculateApr(loan, instalment, term) {
    var result = parseFloat(0);
    var high = parseFloat(200);
    var low = parseFloat(0);
    var n;
    var x;
    var j;
    var q;
    var y;
    var z;

    n = term + 1;
    x = 1;

    while (x < 20) {
      result = (high + low) / 2;

      j = parseFloat(Math.pow(1.0 + result / 100.0, 1.0 / 12.0));
      q = parseFloat(1.0 / j);
      y = parseFloat((instalment * (1.0 - Math.pow(q, n))) / (1 - q) - instalment);
      z = parseFloat(0.0);

      if (y - z < loan) {
        high = result;
      } else {
        low = result;
      }

      x++;
    }

    return result;
  }

  function generateDescription(financeCalculation) {
    let description = '|cashPrice||amountOfCredit||repayable||apr||annualRate||totalRepayable|';
    description = description.replace('|cashPrice|', 'Total cash price: &pound;' + financeCalculation.cashPrice + '. ');
    description = description.replace('|amountOfCredit|', 'Amount of credit: &pound;' + financeCalculation.loanAmount + '. ');
    let repayableText = 'Repayable by ';
    if (financeCalculation.initialPayments !== financeCalculation.finalPayment && financeCalculation.finalPayment > 0) {
      repayableText +=
        financeCalculation.months -
        1 +
        ' monthly repayments of &pound;' +
        financeCalculation.initialPayments +
        ' and a final payment of &pound;' +
        financeCalculation.finalPayment +
        '. ';
    } else {
      repayableText += financeCalculation.months + ' monthly repayments of &pound;' + financeCalculation.initialPayments + '. ';
    }
    description = description.replace('|repayable|', repayableText);
    description = description.replace('|apr|', 'Representative APR ' + financeCalculation.apr + '%. ');
    description = description.replace('|annualRate|', 'Annual rate of interest ' + financeCalculation.annualRate + '% fixed. ');
    description = description.replace(
      '|totalRepayable|',
      'Total amount repayable &pound;' + financeCalculation.amountPayable + ' including total interest of &pound;' + financeCalculation.interest + '.'
    );

    return description;
  }
})();

(function FinanceModel() {
  var financeThreshold = Simba.Liquid.number('"15000"');
  var instalment12Threshold = Simba.Liquid.number('"25000"');
  var instalmentLowerThresholdMonths = Simba.Liquid.number('"12"');
  var format = Simba.Functional.partial(Simba.Money.format, Simba.Liquid.string('"£{{amount}}"'));
  var formatWithoutTrailingZeros = Simba.Functional.partial(
    Simba.Money.format,
    Simba.Liquid.string('"£{{amount_no_decimals}}"')
  );

  if (!Simba.Cart) return false;

  if (Simba.Cart) {
    setModel(Simba.Cart);
  }

  Simba.FinanceModel = {
    setModel: setModel
  };

  function setModel(obj) {
    obj.finance = {};

    Object.defineProperties(obj.finance, {
      originalPrice: {
        get: function () {
          return originalPrice(obj);
        }
      },
      originalPriceFormatted: {
        get: function () {
          return format(this.originalPrice);
        }
      },
      originalPriceFormattedWithoutTrailingZeros: {
        get: function () {
          return formatWithoutTrailingZeros(this.originalPrice);
        }
      }
    });

    Object.defineProperties(obj.finance, {
      price: {
        get: function () {
          return price(obj);
        }
      },
      priceFormatted: {
        get: function () {
          return format(this.price);
        }
      },
      priceFormattedWithoutTrailingZeros: {
        get: function () {
          return formatWithoutTrailingZeros(this.price);
        }
      }
    });

    Object.defineProperty(obj.finance, 'hasDiscount', {
      get: function () {
        return originalPrice(obj) > price(obj);
      }
    });

    Object.defineProperty(obj.finance, 'hasFinance', {
      get: function () {
        return hasFinance(obj);
      }
    });

    Object.defineProperty(obj.finance, 'lowestInstalmentPriceFormatted', {
      get: function () {
        var instalmentMonth = hasInstalment12Hidden(obj) ? instalmentLowerThresholdMonths : parseInt('48', 10);
        var useMultipler = !hasInstalment12Hidden(obj) && 'v12' === 'multiplier';
        var useV12calculations = !hasInstalment12Hidden(obj) && 'v12' === 'v12';
        return format(pricePerInstalment(obj, instalmentMonth, useMultipler, useV12calculations));
      }
    });

    Object.defineProperty(obj.finance, 'originalInstalmentPriceFormatted', {
      get: function () {
        // instalment period of the variant e.g. 12 or 48
        var instalmentMonth = this.instalmentMonths;
        var useMultipler = !hasInstalment12Hidden(obj) && 'v12' === 'multiplier';
        var useV12calculations = !hasInstalment12Hidden(obj) && 'v12' === 'v12';
        const result = format(pricePerInstalment(obj, instalmentMonth, useMultipler, useV12calculations, true));
        return result;
      }
    });

    Object.defineProperty(obj.finance, 'hasInstalment12Hidden', {
      get: function () {
        return hasInstalment12Hidden(obj);
      }
    });

    Object.defineProperty(obj.finance, 'instalmentMonths', {
      get: function () {
        return hasInstalment12Hidden(obj) ? instalmentLowerThresholdMonths : parseInt('48', 10);
      }
    });

    Object.defineProperty(obj.finance, 'instalmentPriceFormatted', {
      get: function () {
        var allInstalments = [3, 6, 12];
        /**/
        allInstalments.push(30);
        /**/

        return allInstalments
          .map(function (instalment) {
            return pricePerInstalment(obj, instalment, false, false);
          })
          .map(format);
      }
    });
  }

  function hasInstalment12Hidden(obj) {
    var logicPrice = price(obj);
    return logicPrice < instalment12Threshold;
  }

  function hasFinance(obj) {
    var logicPrice = price(obj);
    return logicPrice > financeThreshold;
  }

  function originalPrice(obj) {
    return obj.type === 'variant' ? obj.originalPrice : obj.original_total_price;
  }

  function price(obj) {
    return obj.type === 'variant' ? obj.price : obj.total_price;
  }

  function pricePerInstalment(obj, n, useMultiplyer, useV12calculations, useOriginal) {
    var itemprice = useOriginal ? originalPrice(obj) : price(obj);

    if (useMultiplyer) {
      // eslint-disable-next-line vars-on-top
      var multiplyer = parseFloat('0.0268780');
      return Math.floor(itemprice * multiplyer);
    }

    if (useV12calculations) {
      const numberOfInstalments = parseInt('48', 10);
      var v12Values = Simba.V12Finance.calculateV12Values(itemprice / 100, numberOfInstalments);
      return v12Values.initialPayments;
    }

    return itemprice / n;
  }
})();
/**/

(function VariantModel() {
  // var variants;
  var discountData = Simba.ProductDiscount;
  var financeThreshold = Simba.Liquid.number('"15000"');
  var format = Simba.Functional.partial(Simba.Money.format, Simba.Liquid.string('"£{{amount}}"'));
  var formatWithoutTrailingZeros = Simba.Functional.partial(
    Simba.Money.format,
    Simba.Liquid.string('"£{{amount_no_decimals}}"')
  );

  Simba.VariantModel = {
    setModel: setModel
  };

  function setModel(variant) {
    variant.type = 'variant';

    Object.defineProperties(variant, {
      price: {
        get: function () {
          return getPrice(this);
        }
      },
      priceFormatted: {
        get: function () {
          return format(this.price);
        }
      },
      priceFormattedWithoutTrailingZeros: {
        get: function () {
          return formatWithoutTrailingZeros(this.price);
        }
      }
    });

    Object.defineProperties(variant, {
      originalPrice: {
        get: function () {
          return this.priceRaw;
        }
      },
      originalPriceFormatted: {
        get: function () {
          return format(this.originalPrice);
        }
      },
      originalPriceFormattedWithoutTrailingZeros: {
        get: function () {
          return formatWithoutTrailingZeros(this.originalPrice);
        }
      }
    });

    Object.defineProperty(variant, 'hasDiscount', {
      get: function () {
        if (variant.external) return false;
        if (variant.excluded_from_discount) return false;
        return getPrice(this) < this.priceRaw;
      }
    });

    Object.defineProperty(variant, 'hasCompareAtPrice', {
      get: function () {
        if (variant.external) return false;
        return getPrice(this) < this.compareAtPriceRaw;
      }
    });

    Object.defineProperty(variant, 'hasFinance', {
      get: function () {
        return hasFinance(this);
      }
    });
  }

  function getPrice(variant) {
    var percentagePerProduct;
    var amountOffPerProduct;
    var discountedPrice;
    var discountSource;

    if (variant.external) {
      return variant.priceRaw;
    }

    if (Simba.ProductDiscount.type === 'global') {
      return percentage(variant.priceRaw, discountData.discount.percentage);
    }

    if (variant.excluded_from_discount) return variant.priceRaw;

    if (Simba.ProductDiscount.type === 'partial') {
      if (variant.productGroup.handle) {
        discountSource = discountData.discount.product_groups[variant.productGroup.handle] ?? discountData.discount[variant.handle];
      } else {
        discountSource = discountData.discount[variant.id] ?? discountData.discount[variant.handle] ?? null;
      }

      percentagePerProduct = discountSource ? discountSource.percentage : 0;
      amountOffPerProduct = discountSource ? discountSource.amount : 0;

      if (typeof percentagePerProduct !== 'undefined') {
        discountedPrice = percentage(variant.priceRaw, percentagePerProduct);
      }
      if (typeof amountOffPerProduct !== 'undefined') {
        discountedPrice = variant.priceRaw - amountOffPerProduct * 100;
      }

      return discountedPrice;
    }

    return variant.priceRaw;
  }

  function hasFinance(obj) {
    return getPrice(obj) + Simba.Cart.total_price >= financeThreshold;
  }

  function percentage(n, percent) {
    return Number(n) - (Number(percent) / 100) * Number(n);
  }
})();

/**
 * Global utils.
 */
(function Cookies() {
  Simba.Cookie = {
    create: cookieCreate,
    read: cookieRead,
    erase: cookieErase
  };

  /**
   * Create cookie.
   * @param {String} name
   * @param {String} value
   * @param {Number} days
   * @param {Boolean|String} secure
   */
  function cookieCreate(name, value, days, secure) {
    var date;
    var expires;
    if (days) {
      date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    } else {
      expires = '';
    }

    secure = typeof secure === 'undefined' ? true : secure;
    secure = secure === true ? 'secure;' : '';
    document.cookie = name + '=' + value + expires + '; path=/;' + secure;
  }

  /**
   * Read cookie.
   * @param {String} name
   */
  function cookieRead(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    var i;
    var c;
    for (i = 0; i < ca.length; i++) {
      c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Erase cookie.
   * @param {String} name
   */
  function cookieErase(name) {
    cookieCreate(name, '', -1);
  }
})();

(function Event() {
  Simba.Event = {
    emit: emitEvent
  };

  /**
   * Event emitter util.
   * @param {String} type Event custom type.
   * @param {Object} data Event detail.
   * @example
   *   Dispatch: Simba.Event.emit('cart:change', {cart_total: 24})
   *   Listen:   document.addEventListener('cart:change', processEvt, false);
   */
  function emitEvent(type, data) {
    var event = new CustomEvent(type, { detail: data });

    try {
      document.dispatchEvent(event);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
})();

(function AnimationObserver() {
  var instances;
  if (!document.querySelectorAll('[data-animation-init]')) return false;
  instances = [].slice.call(document.querySelectorAll('[data-animation-init]'));
  instances.forEach(init);

  /**
   * Init IntersectionObserver for each '[data-animation-init]' configuration element.
   * @param {HTMLElement} config script with [data-animation-init] attribute.
   * @example
   *   <script data-animation-init type="application/json">
   *     {
   *       "trigger": "[data-animation-trigger]",
   *       "animation": "[data-animation]",
   *       "threshold": "1",
   *       "rootMargin": "-180px"
   *     }
   *   </script>
   */
  function init(instance) {
    var config = JSON.parse(instance.innerHTML);
    var animationContainer = document.querySelector(config.animation);
    var animationTrigger = document.querySelector(config.trigger);
    var threshold = Number(config.threshold) || 1;
    var rootMargin = config.rootMargin || '0px';

    var options = {
      rootMargin: rootMargin,
      threshold: [0, threshold]
    };

    new IntersectionObserver(callback, options).observe(animationTrigger);

    /**
     * IntersectionObserver callback fn.
     * @param {Object} entries A list of IntersectionObserverEntry objects
     */
    function callback(entries) {
      var entry = entries[0];

      entry.isIntersecting || entry.boundingClientRect.y < 0
        ? animationContainer.classList.add('active')
        : animationContainer.classList.remove('active');
    }
  }
})();

// Compare modal, quick and dirty
(function Modal() {
  $('[data-js-modal-trigger]').on('click', function (evt) {
    evt.preventDefault();
    $('[data-js-modal="compare-modal"]').removeAttr('hidden');
  });

  $('[data-js-modal-close]').on('click', function (evt) {
    evt.preventDefault();
    $('[data-js-modal="compare-modal"]').attr('hidden', true);
  });
})();

/**
 * Tabs.
 * @return {Array} public API.
 */
(function Tabs() {
  var instances = $.makeArray($('[data-js-tabs]'));
  var init = Simba.Functional.compose(setEvents, collateData);

  var publicAPI = instances.map(init);
  Simba.Tabs = publicAPI;
  return publicAPI;

  // **************************

  /**
   * Get elements.
   * @param {HTMLElement} trigger Button with data-js-collapsible attribute.
   * @return {Object} Object with instance data.
   */
  function collateData(instance) {
    return {
      instance: instance,
      triggers: $.makeArray(instance.querySelectorAll('[role="tab"]')),
      panels: $.makeArray(instance.querySelectorAll('[role="tabpanel"]'))
    };
  }

  /**
   * Add 'click' events.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function setEvents(obj) {
    obj.triggers.forEach(function setEvent(trigger) {
      var panel = obj.instance.querySelector('#' + trigger.getAttribute('aria-controls'));
      trigger.addEventListener('click', Simba.Functional.partial(expand, obj, trigger, panel));
    });

    return obj;
  }

  /**
   * Expand panel.
   * @param {Object} obj Instance data.
   * @return {Object} Instance data.
   */
  function expand(obj, trigger, panel) {
    obj.panels.map(function (instancePanel) {
      return instancePanel.id === panel.id
        ? { panel: instancePanel, direction: 'reverse' }
        : {
            panel: instancePanel,
            direction: 'normal'
          };
    });

    obj.panels.forEach(function setPanelState(instancePanel) {
      instancePanel.id === panel.id ? instancePanel.removeAttribute('hidden') : instancePanel.setAttribute('hidden', true);
    });

    obj.triggers.forEach(function setTriggerState(instanceTrigger) {
      instanceTrigger.id === trigger.id ? instanceTrigger.setAttribute('aria-selected', true) : instanceTrigger.setAttribute('aria-selected', false);
      instanceTrigger.id === trigger.id ? instanceTrigger.removeAttribute('tabindex', true) : instanceTrigger.setAttribute('tabindex', '-1');
    });

    return obj;
  }
})();

/**
 * Get Accurate Viewport Width
 */
(function Viewport() {
  Simba.Viewport = function () {
    var e = window;
    var a = 'inner';
    // eslint-disable-next-line no-restricted-syntax
    if (!('innerWidth' in window)) {
      a = 'client';
      e = document.documentElement || document.body;
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] };
  };
})();

/**
 *  -- Horizontal Scroll Polyfill Function --
 *  Func to act as polyfill for scrollIntoView with container option.
 *  this is needed to isolate the scroll to just the colour selector container instead of the whole page
 *  not supported in Safari or Firefox, so we need a fallback for now https://caniuse.com/wf-scroll-into-view-container
 *  when supported we can replace the scrollCenterHorizontal function with the below
 *  select.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest', container: 'nearest' });
 */
(function ScrollCenterHorizontal() {
  Simba.ScrollCenterHorizontal = (container, element) => {
    const cRect = container.getBoundingClientRect();
    const eRect = element.getBoundingClientRect();

    // Calculate the center point of the container
    const containerCenter = cRect.left + cRect.width / 2;
    // Calculate the center point of the element
    const elementCenter = eRect.left + eRect.width / 2;

    // The distance to move is the difference between these two centers
    const diff = elementCenter - containerCenter;
    container.scrollTo({
      left: container.scrollLeft + diff,
      behavior: 'smooth'
    });
  };
})();

/**
 * Scroll To Function
 */
(function ScrollTo() {
  Simba.ScrollTo = function (el) {
    var i;
    var links = document.querySelectorAll('.scroll-to');
    if (el) {
      window.scroll({
        top: el.offsetTop,
        behavior: 'smooth'
      });
    } else {
      for (i = 0; i < links.length; i++) {
        links[i].addEventListener('click', function (e) {
          var href = this.getAttribute('href');
          var offsetTop = document.querySelector(href).offsetTop;
          e.preventDefault();
          window.scroll({
            top: offsetTop,
            behavior: 'smooth'
          });
        });
      }
    }
  };
  Simba.ScrollTo();
})();

/**
 * Storefront API Wrapper
 */
(function StorefrontAPI() {
  Simba.StorefrontAPI = {
    call: call
  };

  /**
   * Storefront API Call
   * @param {String} payload JSON Stringified payload for the call
   * @return {Object} Storefront API Response
   */
  async function call(payload) {
    const response = await fetch('https://simbasleep.com/api/2025-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '2cedcc2a1bd3f769c90bae3c6cd6eb55'
      },
      body: payload
    });

    // Await & Return Response
    const responseJson = await response.json();
    return responseJson;
  }
})();

/**
 * Product Logic
 */
(function ProductLogic() {
  var productsCache = {};

  Simba.ProductAsync = {
    /**
     * Load Product Data From Variant ID
     *
     * @param {Integer} variantId Variant ID of the variant to load
     * @return {Object} Variant Data
     */
    load: async function (variantId) {
      // Return Value If Exists In Cache
      if (typeof productsCache[variantId] !== 'undefined') {
        return productsCache[variantId];
      }

      // Set Handle
      const handle = await this.handle(variantId);
      if (typeof handle === 'undefined') {
        return undefined;
      }

      // Use Navigator Lock To Lock The Thread - https://developer.mozilla.org/en-US/docs/Web/API/Web_Locks_API
      // Return Value If Exists In Cache or Lookup Via Logic Template
      if (typeof navigator !== 'undefined' && navigator.locks) {
        const variantData = await navigator.locks.request(handle, async () => {
          if (typeof productsCache[variantId] !== 'undefined') {
            return productsCache[variantId];
          }

          const lookupVariantData = await this.data(handle, variantId);

          return lookupVariantData;
        });

        // Return Variant Data
        return variantData;
      }

      // Return Variant Data without using the lock (for older browsers)
      return this.data(handle, variantId);
    },

    /**
     * Get Product Handle From Variant ID Using Storefront API
     *
     * @param {Integer} variantId Variant ID of the variant to load
     * @return {String} Product handle for variant
     */
    handle: async function (variantId) {
      // Product Async Storefront Call
      const base64Id = btoa(`gid://shopify/ProductVariant/${variantId}`);
      const response = await Simba.StorefrontAPI.call(
        JSON.stringify({
          query: `
            query {
              node(id: "${base64Id}") {
                ... on ProductVariant {
                  product {
                    handle
                  }
                }
              }
            }
          `,
          variables: {}
        })
      );

      // Return Handle
      return response?.data?.node?.product?.handle;
    },

    /**
     * Load Product Data From Store Logic Template
     *
     * @param {String} handle Product handle to lookup
     * @param {Integer|Boolean} variantId Variant ID of the variant to load, leave blank or false to return all variants for the product handle
     *
     * @return {Object} Variant(s) Data
     */
    data: async function (handle, variantId = false) {
      if (typeof handle === 'undefined') {
        return undefined;
      }

      // Pull Product Data From Store
      const variantResponse = await fetch(`/products/${handle}?view=logic`);
      if (variantResponse.ok) {
        const variants = await variantResponse.json();

        for (const variant of Object.values(variants)) {
          Simba.VariantModel.setModel(variant);
          Simba.FinanceModel.setModel(variant);

          productsCache[variant.id] = variant;
        }

        // Return Single Variant If Specified
        if (variantId) {
          return variants[variantId];
        }

        // Otherwise, Return All Product Variants
        return variants;
      }
      return undefined;
    },

    /**
     * Load Product Data From Store Logic Template
     *
     * @param {String} productHandles Product handle to lookup
     * @param {Integer|Boolean} variantId Variant ID of the variant to load, leave blank or false to return all variants for the product handle
     *
     * @return {Object} Variant(s) Data
     */
    getProductGroupIds: async function (productHandles) {
      // Return Value If Exists In Cache
      if (!productHandles) {
        return productHandles;
      }

      const variants = await Promise.all(
        productHandles.map(async (handle) => {
          try {
            const response = await Simba.StorefrontAPI.call(
              JSON.stringify({
                query: `
                query getProductDetails($handle: String!) {
                  product(handle: $handle) {
                    variants(first: 100) {
                      nodes {
                        id
                      }
                    }
                  }
                }
              `,
                variables: { handle }
              })
            );
            return response?.data?.product?.variants?.nodes;
          } catch (error) {
            return { error };
          }
        })
      );

      if (!variants || variants[0] === undefined || variants[0].error) {
        return [];
      }
      const rawIds = variants.flat().flatMap((variant) => {
        const variantId = variant.id.split('/');
        return Number(variantId[variantId.length - 1]);
      });
      return rawIds;
    }
  };
})();

(function ContainerDrag() {
  const TARGET = '[data-drag-scroll]';
  let active = null;

  addEventListener(
    'pointerdown',
    (e) => {
      if (e.button !== 0) return;
      const root = e.target.closest(TARGET);
      if (!root || e.pointerType !== 'mouse' || root.scrollWidth <= root.clientWidth) return;
      active = root;
      root.classList.add('dragging');
      root.setPointerCapture?.(e.pointerId);
      e.preventDefault();
    },
    { passive: false }
  );

  addEventListener(
    'pointermove',
    (e) => {
      if (!active) return;
      const speed = parseFloat(active.dataset.speed) || 50;
      active.scrollLeft -= e.movementX * speed;
    },
    { passive: true }
  );

  function end() {
    if (active) {
      active.classList.remove('dragging');
      active = null;
    }
  }

  addEventListener('pointerup', end, { passive: true });
  addEventListener('pointercancel', end, { passive: true });
})();

/**
 * Sweeps up the scroll restore marker written by ScrollAnchorRestore.
 *
 * That module only loads on product layouts, so a visitor who clicks a product set
 * selector link and then lands anywhere else — a 404, a blog post, the cart, a
 * collection — would leave the marker sitting in sessionStorage for the rest of the
 * session. This runs on every layout and clears the marker unless this page is the
 * destination it was written for, which makes "the marker never outlives one
 * navigation" a literal invariant.
 *
 * core.js is deferred in <head> and bundle.product.js is deferred in <body>, and
 * deferred scripts run in document order, so this always runs first. The predicate,
 * including the 10s TTL, matches the one in scroll-anchor-mask.liquid: it must never
 * drop a marker the page was masked for.
 */
(function ScrollAnchorSweep() {
  var KEY = 'scrollRestore';

  try {
    var raw = sessionStorage.getItem(KEY);

    if (!raw) {
      return;
    }

    var marker = JSON.parse(raw);

    var stale =
      !marker ||
      typeof marker.href !== 'string' ||
      typeof marker.t !== 'number' ||
      Date.now() - marker.t > 10000 ||
      marker.href.split('?')[0] !== location.href.split('?')[0] ||
      !!location.hash;

    if (stale) {
      sessionStorage.removeItem(KEY);
    }
  } catch (error) {
    try {
      sessionStorage.removeItem(KEY);
    } catch (inner) {
      // Storage unavailable entirely; nothing to sweep.
    }
  }
})();
